// Logged-in app page: clip-pack detail (routes/PackDetail.tsx). Keep keys in sync with
// en/appPackDetail.ts.
//
// Sesja 33: okruszek prowadzi do zakładki „Klipy”, stan paczki stoi w linii pod tytułem,
// a paczka EDIMI nosi ETYKIETĘ „tylko do odczytu” zamiast zdania (zasada 8).
//
// USUNIĘTE PRZY IMPLEMENTACJI PACZKI 33: blok `credit.*` (martwe klucze, nigdzie się nie
// renderowały — MAPA 33, „Otwarte”) i `frameCheck.*` (porównanie klatek wyleciało
// z wnętrza paczki; w Przeglądzie został sam przełącznik `appPackQa.blink.label`).
export const appPackDetail = {
  crumb: 'Klipy',
  readOnly: 'tylko do odczytu',
  // Runda 33-R4 (reguła 57): „⋯” w wierszu tytułu niesie rzadkie akcje paczki; jego nazwa
  // dla czytnika ekranu, pozycje menu i pigułka stanu funkcji przy tytule.
  more: 'Więcej',
  menu: {
    select: 'Zaznacz',
    moveToCollection: 'Przenieś do kolekcji',
    merge: 'Scal z inną paczką',
    delete: 'Usuń paczkę',
  },
  // Wgrywanie w toku: liczba plików jako dana nad paskiem postępu.
  upload: {
    files: 'pliki {done} z {total}',
  },
  // Okno kasujące: pytanie z nazwą i tabela danych (bez zdania objaśnienia).
  delete: {
    ask: 'Usunąć „{name}”?',
    rowClips: 'Klipy',
    rowDuration: 'Czas',
    rowCollection: 'Kolekcja',
  },
  toolbar: {
    review: 'Przejrzyj klipy',
    addFiles: 'Dodaj pliki',
    markReviewed: 'Oznacz jako sprawdzoną',
    unmarkReviewed: 'Cofnij „sprawdzoną”',
    reviewFailed: 'Nie udało się zapisać stanu paczki.',
  },
  clip: {
    openPreview: 'Otwórz klip {n}',
    deleteTitle: 'Usuń klip',
    deleteAsk_one: 'Usunąć {n} klip?',
    deleteAsk_few: 'Usunąć {n} klipy?',
    deleteAsk_many: 'Usunąć {n} klipów?',
    deleteAsk: 'Usunąć {n} klipów?',
    deleteCancel: 'Anuluj',
  },
  selection: {
    enter: 'Zaznacz',
    cancel: 'Anuluj',
    selectClip: 'Zaznacz klip {n}',
    selected_one: '{n} zaznaczony',
    selected_few: '{n} zaznaczone',
    selected_many: '{n} zaznaczonych',
    move: 'Przenieś',
    copy: 'Kopiuj',
    delete: 'Usuń klipy',
    deleteCount: 'Usuń ({n})',
  },
  transfer: {
    moveTitle: 'Przenieś klipy do innej paczki',
    copyTitle: 'Skopiuj klipy do innej paczki',
    target: 'Paczka docelowa',
    targetPlaceholder: 'Wybierz paczkę',
    emptyTitle: 'Nie ma innej gotowej paczki.',
    cancel: 'Anuluj',
    confirmMove: 'Przenieś klipy',
    confirmCopy: 'Skopiuj klipy',
    failed: 'Nie udało się przenieść klipów.',
  },
  preview: {
    close: 'Zamknij podgląd',
    errorTitle: 'Nie udało się odtworzyć klipu.',
  },
  toast: {
    marked: 'Oznaczono jako sprawdzoną.',
    clipsDeleted_one: 'Usunięto {n} klip.',
    clipsDeleted_few: 'Usunięto {n} klipy.',
    clipsDeleted_many: 'Usunięto {n} klipów.',
    clipsDeleted: 'Usunięto {n} klipów.',
    moved_one: 'Przeniesiono {n} klip.',
    moved_few: 'Przeniesiono {n} klipy.',
    moved_many: 'Przeniesiono {n} klipów.',
    moved: 'Przeniesiono {n} klipów.',
    copied_one: 'Skopiowano {n} klip.',
    copied_few: 'Skopiowano {n} klipy.',
    copied_many: 'Skopiowano {n} klipów.',
    copied: 'Skopiowano {n} klipów.',
    deleteFailed: 'Nie udało się usunąć klipów.',
  },
  empty: {
    short: 'Brak klipów',
  },
  error: {
    title: 'Nie udało się wczytać paczki',
    retry: 'Spróbuj ponownie',
  },
}
